import { action, observable } from "mobx";
import makeApi, { URLS } from "Utils/apiURL";
import { toasterState } from "Components/common/toaster";

/**
 * Account-list picker popup state (list-builder "Save to account list").
 * Account lists hold COMPANIES — separate from contact lists.
 */
class AccountListPickerState {
  @observable showPopup = false;
  @observable lists = [];
  @observable listsLoading = false;
  @observable saving = false;
  companies = []; // [{domain, name}] captured when the popup opens

  @action
  open = (companies = []) => {
    this.companies = companies;
    this.showPopup = true;
    this.fetchLists();
  };

  @action
  close = () => {
    this.showPopup = false;
    this.companies = [];
  };

  @action
  fetchLists = async () => {
    this.listsLoading = true;
    const response = await makeApi({ url: URLS.accountLists, method: "GET" });
    this.lists = response?.data?.data || [];
    this.listsLoading = false;
  };

  @action
  createList = async name => {
    const response = await makeApi({
      url: URLS.accountLists,
      method: "POST",
      data: { name }
    });
    if (response?.data?.id) {
      return response.data;
    }
    toasterState.setToastMsg(
      response?.status === 409 || response?.response?.status === 409
        ? "An account list with this name already exists"
        : "Couldn't create the account list",
      "failure"
    );
    return null;
  };

  @action
  saveToList = async list => {
    if (!list?.id || this.saving) return false;
    this.saving = true;
    const response = await makeApi({
      url: `${URLS.accountLists}/${list.id}/companies`,
      method: "POST",
      data: { companies: this.companies }
    });
    this.saving = false;
    const result = response?.data || {};
    if (result.added !== undefined) {
      const created = result.accounts_created || 0;
      toasterState.setToastMsg(
        `Saved ${result.added} compan${result.added === 1 ? "y" : "ies"} to "${
          list.name
        }"${created ? ` (${created} new account${created === 1 ? "" : "s"})` : ""}`,
        "success"
      );
      this.close();
      return true;
    }
    toasterState.setToastMsg("Couldn't save to the account list", "failure");
    return false;
  };
}

export const accountListPickerState = new AccountListPickerState();
export default accountListPickerState;
